<template>
  <div>
    <b-form @submit.prevent="handleSubmitCredentials()">
      <b-form-group :label="$t('general.name')">
        <b-form-input
          v-model="$v.name.$model"
          :class="$v.name.$error && 'is-invalid'"
          trim
        >
          <b-form-invalid-feedback v-if="!$v.name.required">
            {{ $t("auth.type-valid-name") }}
          </b-form-invalid-feedback>
        </b-form-input>
      </b-form-group>
      <b-form-group label="Descrição">
        <b-form-textarea
          v-model="$v.summary.$model"
          :class="$v.summary.$error && 'is-invalid'"
          trim
        ></b-form-textarea>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button size="sm" variant="link" @click="$emit('submited')">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          type="submit"
          variant="primary"
          :disabled="isLoading"
          class="pull-right text-right"
        >
          <b-spinner v-if="isLoading" small class="mr-2" />
          <span> {{ $t("general.save") }}</span>
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  mixins: [validationMixin],

  data() {
    return {
      document_id: "",
      isLoading: false,
      name: null,
      summary: null,
      admin: false,
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(4),
    },
    summary: {
      required,
    },
  },
  methods: {
    ...mapActions([
      "add_document_type",
      "edit_document_type",
      "show_toast",
      "get_document_type",
    ]),

    afterSave(error) {
      this.isLoading = false;
      this.$emit("submited");
      if (error) {
        return this.show_toast({
          message: error,
          type: "error",
        });
      }
      this.show_toast({
        message: this.document_id ? "Edição realizada com sucesso" : "Cadastro realizado com sucesso",
        type: "success",
      });
    },

    saveQuestionType() {
      this.add_document_type({
        name: this.name,
        summary: this.summary,
      })
        .then(({ status }) => {
          if ([200, 201].includes(status)) {
            this.afterSave(null);
          } else {
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.afterSave(err);
        });
    },

    editQuestionType() {
      this.edit_document_type({
        id: this.document_id,
        name: this.name,
        summary: this.summary,
      })
        .then(({ status}) => {
          if ([200, 201].includes(status)) {
            this.afterSave(null);
          }
        })
        .catch((err) => {
          this.afterSave(err);
        });
    },

    handleSubmitCredentials() {
      this.$v.$touch();

      if (!this.$v.$anyError && !this.$v.$anyError) {
        this.isLoading = true;
        if (this.document_id) {
          return this.editQuestionType();
        }
        return this.saveQuestionType();
      }
    },

    getEdit() {
      this.name = "";
      this.summary = "";

      if (this.document_id) {
        this.get_document_type({ id: this.document_id }).then(({ data }) => {
          this.name = data.name;
          this.summary = data.summary;
        });
      }
    },
  },

  mounted() {
    this.document_id = this.$route.params.id;
    if (this.document_id) {
      this.getEdit();
    }
  },
};
</script>

<style scoped lang="scss">
.form-data {
  max-width: 600px;
  margin: 0 auto;
}
</style>
